import { permissionNames } from "@/utils/constants/permissions";
import store from "@/store";

export const notFountRoute = {
  path: "*",
  name: "nopage",
  meta: {
    type: "nopage",
    title: "对不起，您没有权限进行这个操作"
  },
  component: () => import(/* webpackChunkName: "nopage" */ "@/views/NoPage.vue")
};

export const staticRoutes = [
  {
    path: "/",
    name: "login",
    meta: {
      type: "adminlogin",
      title: "登录"
    },
    component: () => import(/* webpackChunkName: "login" */ "@/views/Login.vue")
  },
  {
    path: "/noreg",
    name: "noreg",
    props: true,
    meta: {
      type: "noreg",
      title: "未注册"
    },
    component: () => import(/* webpackChunkName: "noreg" */ "@/views/NoReg.vue")
  },
  {
    path: "/errorpage",
    name: "errorpage",
    props: true,
    meta: {
      type: "errorpage",
      title: "页面错误"
    },
    component: () =>
      import(/* webpackChunkName: "errorpage" */ "@/views/ErrorPage.vue")
  },
  {
    path: "/:customerUrl?/lgscreen",
    name: "lgscreen",
    props: true,
    meta: {
      type: "lgscreen",
      title: "大屏展示",
      perms: [permissionNames.dashboard.largeScreen]
    },
    component: () =>
      import(
        /* webpackChunkName: "lgscreen" */ "@/views/chart/LargeScreenPage.vue"
      )
  },
  {
    path: "/:customerUrl",
    name: "customerlogin",
    meta: {
      type: "adminlogin",
      title: "登录"
    },
    component: () => import(/* webpackChunkName: "login" */ "@/views/Login.vue")
  }
];

export const dynamicRoutes = [
  {
    path: "/admin",
    name: "admin",
    meta: {
      type: "admin"
    },
    component: () =>
      import(/* webpackChunkName: "admin" */ "@/views/admin/Admin.vue"),
    children: [
      {
        path: "chart",
        name: "chart",
        meta: {
          type: "admin",
          navi: {
            iconName: "mdi-chart-box",
            title: "数据看板"
          },
          perms: [permissionNames.dashboard.read]
        },
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */
            "@/views/admin/AdminChart.vue"
          )
      },
      {
        path: "report",
        name: "report",
        meta: {
          type: "admin",
          navi: {
            iconName: "mdi-text-box-search",
            title: () => store.getters["user/naviTitle"].caseList
          },
          perms: [permissionNames.case.read]
        },
        component: () =>
          import(
            /* webpackChunkName: "report" */
            "@/views/admin/AdminCaseReport.vue"
          )
      },
      {
        path: "testperson",
        name: "testperson",
        meta: {
          type: "admin",
          navi: {
            iconName: "mdi-account-multiple",
            title: () => store.getters["user/naviTitle"].personList
          },
          perms: [permissionNames.person.read]
        },
        component: () =>
          import(
            /* webpackChunkName: "testperson" */
            "@/views/admin/AdminTestPerson.vue"
          )
      },
      {
        path: "node",
        name: "confignode",
        meta: {
          type: "admin",
          navi: {
            iconName: "mdi-layers",
            title: () => store.getters["user/naviTitle"].node
          },
          perms: [permissionNames.node.read]
        },
        component: () =>
          import(
            /* webpackChunkName: "confignode" */
            "@/views/admin/AdminConfigNode.vue"
          )
      },
      {
        path: "lbgroup",
        name: "lbgroupbase",
        meta: {
          type: "admin",
          navi: {
            iconName: "mdi-pencil-box-multiple",
            title: () => store.getters["user/naviTitle"].lbGroup
          },
          perms: [
            permissionNames.sca.group.read,
            permissionNames.sca.open.read,
            permissionNames.sca.indv.read
          ]
        },
        component: () =>
          import(
            /* webpackChunkName: "lbgroupbase" */
            "@/views/admin/AdminConfig.vue"
          ),
        children: [
          {
            path: "grouplbgroup",
            name: "grouplbgroup",
            props: () => ({ type: "group" }),
            meta: {
              type: "admin",
              navi: {
                iconName: "mdi-account-multiple-outline",
                title: () => store.getters["user/naviTitle"].lbGroupGroup
              },
              perms: [permissionNames.sca.group.read]
            },
            component: () =>
              import(
                /* webpackChunkName: "grouplbgroup" */
                "@/views/admin/AdminLbGroup.vue"
              )
          },
          {
            path: "openlbgroup",
            name: "openlbgroup",
            props: () => ({ type: "open" }),
            meta: {
              type: "admin",
              navi: {
                iconName: "mdi-earth",
                title: () => store.getters["user/naviTitle"].lbGroupOpen
              },
              perms: [permissionNames.sca.open.read]
            },
            component: () =>
              import(
                /* webpackChunkName: "openlbgroup" */
                "@/views/admin/AdminLbGroup.vue"
              )
          },
          {
            path: "individuallbgroup",
            name: "individuallbgroup",
            props: () => ({ type: "individual" }),
            meta: {
              type: "admin",
              navi: {
                iconName: "mdi-account-outline",
                title: () => store.getters["user/naviTitle"].lbGroupIndv
              },
              perms: [permissionNames.sca.indv.read]
            },
            component: () =>
              import(
                /* webpackChunkName: "individuallbgroup" */
                "@/views/admin/AdminLbGroup.vue"
              )
          }
        ]
      },

      {
        path: "lb",
        name: "lbmanage",
        meta: {
          type: "admin",
          navi: {
            iconName: "mdi-clipboard-text-multiple-outline",
            title: () => store.getters["user/naviTitle"].lbInfo
          },
          perms: [
            permissionNames.lb.settings.read,
            permissionNames.lb.alert.read,
            permissionNames.lb.doc.read,
            permissionNames.lb.groupPattern.read
          ]
        },
        component: () =>
          import(
            /* webpackChunkName: "lbmanage" */
            "@/views/admin/AdminConfig.vue"
          ),
        children: [
          {
            path: "lbinfomanage",
            name: "lbinfomanage",
            meta: {
              type: "admin",
              navi: {
                iconName: "mdi-card-bulleted-settings-outline",
                title: () => store.getters["user/naviTitle"].lbInfoManage
              },
              perms: [permissionNames.lb.settings.read]
            },
            component: () =>
              import(
                /* webpackChunkName: "lbinfomanage" */
                "@/views/admin/AdminLbInfoManage.vue"
              )
          },
          {
            path: "lbwaring",
            name: "lbwaring",
            meta: {
              type: "admin",
              navi: {
                iconName: "mdi-alert-plus-outline",
                title: () => store.getters["user/naviTitle"].lbInfoAlert
              },
              perms: [permissionNames.lb.alert.read]
            },
            component: () =>
              import(
                /* webpackChunkName: "lbwaring" */
                "@/views/admin/AdminLbWaringManage.vue"
              )
          },
          {
            path: "lbdocs",
            name: "lbdocs",
            meta: {
              type: "admin",
              navi: {
                iconName: "mdi-file-search-outline",
                title: () => store.getters["user/naviTitle"].lbInfoDocs
              },
              perms: [permissionNames.lb.doc.read]
            },
            component: () =>
              import(
                /* webpackChunkName: "lbdocs" */
                "@/views/admin/AdminLbDocs.vue"
              )
          },
          {
            path: "lbgrouppattern",
            name: "lbgrouppattern",
            meta: {
              type: "admin",
              navi: {
                iconName: "mdi-briefcase-variant-outline",
                title: () => store.getters["user/naviTitle"].lbGroupPattern
              },
              perms: [permissionNames.lb.groupPattern.read]
            },
            component: () =>
              import(
                /* webpackChunkName: "lbgrouppattern" */
                "@/views/admin/AdminLbGroupPattern.vue"
              )
          },
          {
            path: "lbdefaulttemp",
            name: "lbdefaulttemp",
            meta: {
              type: "admin",
              navi: {
                iconName: "mdi-file-search-outline",
                title: () => store.getters["user/naviTitle"].lbDefaultTemp
              },
              perms: [permissionNames.inConstruction]
            },
            component: () =>
              import(
                /* webpackChunkName: "lbdefaulttemp" */
                "@/views/admin/AdminLbDefaultTempManage.vue"
              )
          }
        ]
      },
      {
        path: "ap",
        name: "appointpages",
        meta: {
          type: "admin",
          navi: {
            iconName: "mdi-calendar-month",
            title: () => store.getters["user/naviTitle"].appointPages
          },
          perms: [permissionNames.appoint.read]
        },
        component: () =>
          import(
            /* webpackChunkName: "appointpages" */
            "@/views/admin/AdminConfig.vue"
          ),
        children: [
          {
            path: "doappoint",
            name: "doappoint",
            meta: {
              type: "admin",
              navi: {
                iconName: "mdi-calendar-month-outline",
                title: () => store.getters["user/naviTitle"].doAppoint
              },
              perms: [permissionNames.appoint.read]
            },
            component: () =>
              import(
                /* webpackChunkName: "doappoint" */
                "@/views/admin/AdminDoAppoint.vue"
              )
          },
          {
            path: "processappoint",
            name: "processappoint",
            props: () => ({ type: "processing" }),
            meta: {
              type: "admin",
              navi: {
                iconName: "mdi-calendar-multiple-check",
                title: () => store.getters["user/naviTitle"].processAppoint
              },
              perms: [permissionNames.appoint.read]
            },
            component: () =>
              import(
                /* webpackChunkName: "processappoint" */
                "@/views/admin/AdminAppointment.vue"
              )
          },
          {
            path: "appointhistory",
            name: "appointhistory",
            props: () => ({ type: "finished" }),
            meta: {
              type: "admin",
              navi: {
                iconName: "mdi-calendar-clock-outline",
                title: () => store.getters["user/naviTitle"].appointHistory
              },
              perms: [permissionNames.appoint.read]
            },
            component: () =>
              import(
                /* webpackChunkName: "appointhistory" */
                "@/views/admin/AdminAppointment.vue"
              )
          }
        ]
      },
      {
        path: "task",
        name: "taskpages",
        meta: {
          type: "admin",
          navi: {
            iconName: "mdi-form-select",
            title: () => store.getters["user/naviTitle"].taskPages
          },
          perms: [permissionNames.task.read]
        },
        component: () =>
          import(
            /* webpackChunkName: "taskpages" */
            "@/views/admin/AdminConfig.vue"
          ),
        children: [
          {
            path: "processtask",
            name: "processtask",
            props: () => ({ type: "process" }),
            meta: {
              type: "admin",
              navi: {
                iconName: "mdi-folder-multiple-outline",
                title: () => store.getters["user/naviTitle"].processTask
              },
              perms: [permissionNames.task.read]
            },
            component: () =>
              import(
                /* webpackChunkName: "processtask" */
                "@/views/admin/AdminTaskManage.vue"
              )
          },
          {
            path: "mycreatetask",
            name: "mycreatetask",
            props: () => ({ type: "created" }),
            meta: {
              type: "admin",
              navi: {
                iconName: "mdi-folder-multiple-outline",
                title: () => store.getters["user/naviTitle"].createdTask
              },
              perms: [permissionNames.task.read]
            },
            component: () =>
              import(
                /* webpackChunkName: "mycreatetask" */
                "@/views/admin/AdminTaskManage.vue"
              )
          }
        ]
      },
      {
        path: "settings",
        name: "settings",
        meta: {
          type: "admin",
          navi: {
            iconName: "mdi-cog",
            title: () => store.getters["user/naviTitle"].settings
          },
          perms: [
            permissionNames.settings.login.user.read,
            permissionNames.settings.login.role.read,
            permissionNames.settings.display.edit,
            permissionNames.settings.userAccount.edit,
            permissionNames.case.rpt.sign
          ]
        },
        component: () =>
          import(
            /* webpackChunkName: "settings" */
            "@/views/admin/AdminSettings.vue"
          )
      }
    ]
  }
];
